/* ===== Goddess Grip theme.js ===== */
(function(){
  'use strict';

  /* -------- Mobile nav -------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav){
    function openNav(){ mobileNav.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeNav(){ mobileNav.classList.remove('open'); document.body.style.overflow = ''; }
    navToggle.addEventListener('click', openNav);
    mobileNav.querySelectorAll('[data-nav-close], a').forEach(function(el){
      el.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeNav(); });
  }

  /* -------- Dispatch countdown to cutoff hour (default 14:00) -------- */
  document.querySelectorAll('[data-dispatch]').forEach(function(box){
    var cutoff = parseInt(box.getAttribute('data-cutoff') || '14', 10);
    var clockEl = box.querySelector('[data-dispatch-clock]');
    var ring = box.querySelector('.progress');
    var msgOpen = box.querySelector('[data-msg-open]');
    var msgClosed = box.querySelector('[data-msg-closed]');
    var R = 28, CIRC = 2 * Math.PI * R;
    if (ring){ ring.style.strokeDasharray = CIRC; }

    function tick(){
      var now = new Date();
      var target = new Date();
      target.setHours(cutoff, 0, 0, 0);
      var past = now >= target;
      if (past){
        // count to next day's cutoff, show "ships tomorrow"
        target.setDate(target.getDate() + 1);
        if (msgOpen) msgOpen.style.display = 'none';
        if (msgClosed) msgClosed.style.display = '';
      } else {
        if (msgOpen) msgOpen.style.display = '';
        if (msgClosed) msgClosed.style.display = 'none';
      }
      var diff = Math.max(0, target - now);
      var h = Math.floor(diff/3.6e6);
      var m = Math.floor((diff%3.6e6)/6e4);
      var s = Math.floor((diff%6e4)/1000);
      if (clockEl){
        clockEl.textContent = (h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
      }
      if (ring){
        // fraction of the working window remaining (window = cutoff hours from midnight)
        var windowMs = (past ? (24 - cutoff + cutoff) : cutoff) * 3.6e6;
        var frac = Math.min(1, diff / (cutoff*3.6e6 || 1));
        ring.style.strokeDashoffset = CIRC * (1 - Math.min(1,frac));
      }
    }
    tick();
    setInterval(tick, 1000);
  });

  /* -------- Product gallery -------- */
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (main && src){ main.src = src; main.alt = alt; }
        g.querySelectorAll('[data-gallery-thumb]').forEach(function(t){ t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });

  /* -------- Purchase type → toggle selling_plan input + live pricing -------- */
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var planInput = form.querySelector('[name="selling_plan"]');
    var wrap      = form.querySelector('[data-purchase-options]');
    var bigPrice  = form.querySelector('[data-price-current]') || document.querySelector('[data-price-current]');
    var subNow    = form.querySelector('[data-sub-now]');
    var subTag    = form.querySelector('[data-sub-tag]');
    var oneTime   = wrap ? wrap.getAttribute('data-onetime') : null;
    function syncPlan(){
      var checkedSub = form.querySelector('input[name="purchase_type"][value="subscription"]:checked');
      var select = form.querySelector('[data-plan-select]');
      var opt = select ? select.options[select.selectedIndex] : null;
      if (planInput){ planInput.value = (checkedSub && select) ? select.value : ''; }
      /* keep the subscribe row showing the selected frequency's discounted price */
      if (opt){
        if (subNow && opt.getAttribute('data-now')) subNow.textContent = opt.getAttribute('data-now');
        if (subTag && opt.getAttribute('data-pct')) subTag.textContent = 'Save ' + opt.getAttribute('data-pct') + '%';
      }
      /* reflect the active choice in the big headline price */
      if (bigPrice){
        if (checkedSub && opt && opt.getAttribute('data-now')) bigPrice.textContent = opt.getAttribute('data-now');
        else if (oneTime) bigPrice.textContent = oneTime;
      }
    }
    form.querySelectorAll('input[name="purchase_type"]').forEach(function(r){
      r.addEventListener('change', syncPlan);
    });
    var sel = form.querySelector('[data-plan-select]');
    if (sel) sel.addEventListener('change', syncPlan);
    syncPlan();
  });

  /* -------- Variant selection -------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function(picker){
    var form = picker.closest('[data-product-form]') || document;
    var idInput = form.querySelector('[name="id"]');
    var variants = {};
    try { variants = JSON.parse(picker.getAttribute('data-variants') || '{}'); } catch(e){}
    picker.querySelectorAll('[data-variant-id]').forEach(function(pill){
      pill.addEventListener('click', function(){
        picker.querySelectorAll('[data-variant-id]').forEach(function(p){ p.setAttribute('aria-checked','false'); });
        pill.setAttribute('aria-checked','true');
        var vid = pill.getAttribute('data-variant-id');
        if (idInput) idInput.value = vid;
        var v = variants[vid];
        var priceEl = document.querySelector('[data-price-current]');
        if (v && priceEl) priceEl.textContent = v.price;
      });
    });
  });

  /* -------- Quantity -------- */
  document.querySelectorAll('[data-qty]').forEach(function(q){
    var input = q.querySelector('input');
    q.querySelector('[data-qty-minus]').addEventListener('click', function(){
      input.value = Math.max(1, parseInt(input.value||'1',10) - 1);
    });
    q.querySelector('[data-qty-plus]').addEventListener('click', function(){
      input.value = parseInt(input.value||'1',10) + 1;
    });
  });

  /* -------- Accordion -------- */
  document.querySelectorAll('[data-accordion]').forEach(function(acc){
    acc.querySelectorAll('.accordion__btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.closest('.accordion__item');
        var panel = item.querySelector('.accordion__panel');
        var open = item.classList.toggle('open');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0';
      });
    });
  });

  /* -------- Scroll reveal -------- */
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
    }, {threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

})();
